import React, {useRef, useState} from 'react';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputTextarea } from "primereact/inputtextarea";
import { useDispatch } from 'react-redux';
import { sendAshaReminder } from '../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionActions';
import { useTranslation } from 'react-i18next';
const SendReminderView = ({ ashaIds, isDisabled }) => {
    const {t}=useTranslation("");
    const [text, setText] = useState('');
    const dispatch = useDispatch();

    const op = useRef(null);

    const handleSend = (e) => {
        op.current.toggle(e);

    }

    const handleSubmit = (e) => {
        dispatch(sendAshaReminder(ashaIds, text));
        setText("");
        op.current.toggle(e);
    }

    const handleCancel = (e) => {
        op.current.toggle(e);
        setText("");
    }

    return (
        <div>
            <Button label={t('sendreminder')} severity="warning" onClick={(e) => handleSend(e)}
                style={{ color: 'white', backgroundColor: '#FFA944', marginRight:"0.3rem"}}
                raised disabled={isDisabled} data-testid="send-reminder-button"/>
            <OverlayPanel ref={op} closeOnEscape={false} >
                <div className="flex flex-column justify-content-center p-2">
                    <div className="text-sm font-semibold mb-2"> {t('Writeamessage')} </div>
                    <div className="mb-2">
                        <InputTextarea autoResize value={text} onChange={(e) => setText(e.target.value)}
                            rows={5} cols={30} data-testid="reminder-message-input"
                            placeholder={t('please write a message')}/>
                    </div>
                    <div className="flex justify-content-center gap-3">
                        <Button onClick={(e) => handleSubmit(e)}  label={t('Submit')} style={{ backgroundColor: '#1D2965'}}
                            disabled={text === ''} tooltip={t('Click to send reminder')}
                            data-testid="submit-button" tooltipOptions={{ position: 'bottom', event: 'both' }} />
                        <Button label={t('Cancel')} outlined onClick={(e) => handleCancel(e)}
                            tooltip={t('Cancel')} tooltipOptions={{ position: 'bottom', event: 'both' }} data-testid="cancel-button"/>
                    </div>
                </div>
            </OverlayPanel>
        </div>
    )
}
export default SendReminderView;
